import React from 'react';
import {Dropdown, Button} from 'web-components';

import {WorkflowCategories, PROJECT_STATUS, BUDGET_TYPE} from '../../../constants';
import {
	InputLineWrapper,
	SubSection,
	InputLineLabel,
	InputLineInput,
	ProjectStatusWrapper,
	StatusDateWrapper,
	PersonStatusWrapper,
	PersonNameStatusWrapper,
	StatusDescriptionTitle,
	StatusDescriptionWrapper,
	ProjectStatusFirstLine,
	GreyText,
	PictureWrapper,
} from './ProjectSettings_styled';
import {changeStage, changeWinChance, changeTasksColumn} from './ProjectSettingsMutations';
import {PercentageInputWrapper} from '../../../components/inputs/percentage_input_wrapper';
import {MODAL_TYPE, showModal} from '../../../forecast-app/shared/components/modals/generic_modal_conductor';
import {TASKS_OPTIONS} from '../../modal/CloseProjectModal';
import Util from '../../../forecast-app/shared/util/util';
import RichTextItem from '../../../components/richtext_item';

const ProjectSettingsStatus = ({
	intl,
	projectId,
	companyProjectId,
	projectStage,
	stages,
	hasOpportunityAccess,
	baselineWinChance,
	projectTasks,
	projectColumns,
	currentProjectStatusColor,
	currentProjectStatusDate,
	currentProjectStatusPersonImage,
	currentProjectStatusPersonFullName,
	currentProjectStatusDescription,
	viewverId,
	projectDoneOrHalted,
	budgetType,
}) => {
	const {formatMessage} = intl;

	const handleUnfinishedWork = (option, statucColumnId, notDoneTasks) => {
		switch (option) {
			case TASKS_OPTIONS.DONE:
				const notDoneIds = notDoneTasks.map(task => task.node.id);
				changeTasksColumn(notDoneIds, statucColumnId);
				changeStage(projectId, PROJECT_STATUS.DONE);
				break;
			case TASKS_OPTIONS.STAY:
				changeStage(projectId, PROJECT_STATUS.DONE);
				break;
			default:
				break;
		}
	};

	const handleChangeStage = stage => {
		if (stage) {
			if (stage === PROJECT_STATUS.DONE) {
				const notDoneTasks = projectTasks.filter(task => task.node.statusColumnV2.category !== PROJECT_STATUS.DONE);
				if (notDoneTasks.length > 0) {
					const doneColumns = projectColumns
						.filter(col => col.node.category === WorkflowCategories.DONE)
						.sort((a, b) => a.node.order - b.node.order)
						.map(col => ({
							value: col.node.id,
							label: col.node.name,
							logo: col.node.jiraStatusId ? 'jira-logo' : undefined,
						}));
					showModal({type: MODAL_TYPE.CLOSE_PROJECT, tasksList: notDoneTasks, doneColumns: doneColumns, callback: (option, statucColumnId) => handleUnfinishedWork(option, statucColumnId, notDoneTasks)});
				} else {
					changeStage(projectId, stage);
				}
			} else {
				changeStage(projectId, stage);
			}
		}
	};

	const showProjectStatusModal = () => {
		showModal({type: MODAL_TYPE.PROJECT_STATUS, viewerId: viewverId, projectId: companyProjectId + ''});
	};

	const parsedCurrentProjectStatusDescription = currentProjectStatusDescription && JSON.parse(currentProjectStatusDescription);

	return (
		<>
			<SubSection title={formatMessage({id: 'settings.project-stage'})}>
				<InputLineWrapper>
					<InputLineLabel>{formatMessage({id: 'settings.project-stage'})}</InputLineLabel>
					<InputLineInput>
						<Dropdown
							name={formatMessage({id: 'settings.project-stage'})}
							selectedItems={[projectStage]}
							onSelect={stage => handleChangeStage(stage[0])}
							customPlaceholder={formatMessage({id: 'empty_state_project_client.select-placeholder'})}
						>
							{stages.map(stage => (
								<Dropdown.SingleText key={stage.value} value={stage.value} searchString={stage.label}>
									{stage.label}
								</Dropdown.SingleText>
							))}
						</Dropdown>
					</InputLineInput>
				</InputLineWrapper>
				{hasOpportunityAccess && budgetType !== BUDGET_TYPE.NON_BILLABLE && (
					<InputLineWrapper>
						<InputLineLabel>{formatMessage({id: 'project_settings.win_chance'})}</InputLineLabel>
						<InputLineInput>
							<PercentageInputWrapper
								width={'70px'}
								disabled={projectStage !== PROJECT_STATUS.OPPORTUNITY}
								// hasError={winChanceError}
								value={baselineWinChance * 100}
								callback={win => changeWinChance(projectId, win)}
								zeroToHundred={true}
							/>
						</InputLineInput>
					</InputLineWrapper>
				)}
			</SubSection>
			<SubSection title={formatMessage({id: 'settings.project-status'})}>
				<ProjectStatusWrapper>
					<ProjectStatusFirstLine>
						<svg data-cy="project-status-color" className="project-status-color" width="24" height="24" viewBox="0 0 24 24" fill="none" disabled={projectDoneOrHalted} onClick={projectDoneOrHalted ? null : showProjectStatusModal}>
							<circle cx="12" cy="12" r="12" fill={currentProjectStatusColor || Util.getProjectStatusColorHex('GREEN')} />
						</svg>
						<StatusDateWrapper>
							<GreyText>{formatMessage({id: 'project_settings.updated_on_colon'})}</GreyText>
							{currentProjectStatusDate}
						</StatusDateWrapper>
						<PersonStatusWrapper>
							<GreyText>{formatMessage({id: 'common.by_colon'})}</GreyText>
							<PictureWrapper>{currentProjectStatusPersonImage}</PictureWrapper>
							<PersonNameStatusWrapper>{currentProjectStatusPersonFullName}</PersonNameStatusWrapper>
						</PersonStatusWrapper>
					</ProjectStatusFirstLine>
					<StatusDescriptionTitle>{formatMessage({id: 'common.description_colon'})}</StatusDescriptionTitle>
					<StatusDescriptionWrapper>
						{parsedCurrentProjectStatusDescription && parsedCurrentProjectStatusDescription.blocks[0] && parsedCurrentProjectStatusDescription.blocks[0].text ? (
							<RichTextItem cy={'status-description'} projectLocked={false} alwaysShowControls={false} readOnly={true} text={currentProjectStatusDescription} placeholder={''} />
						) : (
							<span className={'no-description'}>{formatMessage({id: 'common.no_description_three_dots'})}</span>
						)}
					</StatusDescriptionWrapper>
					<div>
						<Button size={Button.SIZE.STANDARD} variant={Button.VARIANT.VERY_LIGHT_GRAY_OUTLINE} onClick={showProjectStatusModal} disabled={projectDoneOrHalted}>
							{formatMessage({id: 'project_settings.change_project_status'})}
						</Button>
					</div>
				</ProjectStatusWrapper>
			</SubSection>
		</>
	);
};

export default ProjectSettingsStatus;
